import implyVariantFromSelections from "./implyVariantFromSelections";

export default ({ selectedColourWayId, selectedVariantId, variants }) => {
  const { isVariantLowInStock, isVariantInStock } = implyVariantFromSelections({
    selectedColourWayId,
    selectedVariantId,
    variants
  });

  return {
    isVariantLowInStock,
    isVariantInStock
  };
};
